import { render, staticRenderFns } from "./enrollmentorireport.vue?vue&type=template&id=681732b0&scoped=true&"
import script from "./enrollmentorireport.vue?vue&type=script&lang=js&"
export * from "./enrollmentorireport.vue?vue&type=script&lang=js&"
import style0 from "./enrollmentorireport.vue?vue&type=style&index=0&id=681732b0&prod&lang=css&"
import style1 from "./enrollmentorireport.vue?vue&type=style&index=1&id=681732b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681732b0",
  null
  
)

export default component.exports